export const enum ReferralStatus {
  PENDING = 'Pending',
  COMPLETED = 'Completed',
}
